const MobileHeader = ({ children }: { children: React.ReactNode }) => {
  return (
    <header className="fixed top-0 left-0 right-0 z-10 flex h-[68px] w-full items-center justify-between border-b border-white/10 bg-[#152a2b] px-4 text-[#fff9f1] shadow-lg shadow-[#152a2b]/10">
      {children}
    </header>
  );
};

export default MobileHeader;
